module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"draftTitle":"This Form does not yet have a published version. It will not appear on devices until a Draft is published. Once you publish the Form, the settings shown here will be used.","field":{"state":"State","appUserAccess":"App User Access"}}}')
  delete Component.options._Ctor
}
